import { ReportLayout } from '@app/components/reports/components/report-layout';
import { useParams } from 'react-router-dom';
import PurchaseReportLayoutHeader from './components/purchase-report-layout-header';
import { usePurchaseReportResult } from './purchase-report-result-context';
import { usePurchaseReportSections } from './purchase-report-sections';
import { usePurchaseFormattedReportSections } from './purchase-report-utils';
import PurchaseReportIntro from './sections/purchase-report-intro';

export default function PurchaseReport() {
  const { report_uuid } = useParams();
  const { result, resultStatus, resultError, downloadMode } =
    usePurchaseReportResult();

  const reportSections = usePurchaseReportSections(result, report_uuid!);
  const data = usePurchaseFormattedReportSections(reportSections, result);

  return (
    <ReportLayout
      reportType="purchase"
      reportUuid={report_uuid!}
      title={result?.title}
      organizationName={result?.organization.name}
      resultStatus={resultStatus}
      resultError={resultError}
      introComponent={<PurchaseReportIntro />}
      headerComponent={<PurchaseReportLayoutHeader />}
      data={data}
      sections={reportSections}
      defaultActive={'Introduction'}
      downloadMode={downloadMode}
    />
  );
}
